import {PaymentTermType} from "@app/shared/enums/payment-term-type.enum";
import {PaymentTermName} from "@app/shared/enums/payment-term-name.enum"

export class PartnerPaymentTerms {
  id?: number;
  version?: number;
  active: boolean;

  paymentTermType: PaymentTermType;
  paymentTermsName: string;
  standardTermName: string;
  discountIfPaidEarly: number;
  pastDueInterestRate: number;
  daysDueAfterBill: number;
  daysToPayForDiscount: number;
  monthlyTermName: string;
  dayofMonthBillDue: number;
  dayofMonthForDiscount: number;
  dayofMonthForNextMonth: number;
}
